import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { SocketContext } from '../context/SocketContext'
import { useHideMenu } from '../hooks/useHideMenu'
import { useGetPantallas } from '../hooks/useGetPantallas'
import { UseSweetAlert } from '../hooks/useSweetAlert'
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'
import { getPendientes } from '../helpers/gePendientes'

import { TablaTicketsPendientes } from '../components/tablaTicketsPendientes';
import LoadingOverlay from '../components/LoadingOverlay'
import { NoAcceso } from '../components/NoAcceso'
import { NoCargaModulo } from '../components/NoCargaModulo'



// import logo from "../assets/logo.png";

export const Modulo = () => {

    let [usuario] = useState( getUsuarioStorage() )
    const entidad = usuario.entidad;
    const pantallas = useGetPantallas();

    const navigate = useNavigate();
    useEffect(() => {
      if(usuario.uidUsuario === null){
          // return <Navigate to="/ingreso" />
          navigate("/Ingreso")
      }

    }, [usuario.uidUsuario, navigate])

    
    const colores = [
        "success",
        "danger",
        "primary",
        "dark",
        "warning",
        "info",
        "secondary",
        "success",
        "danger",
        "primary",
        "dark",
        "warning",
        "info",
        "secondary",
    ]
    
    useHideMenu(false);
   
    
    const { socket } = useContext( SocketContext );

    const [ticket, setTicket] = useState(null);
    const [pendientes, setPendientes] = useState([]);
    
    const [ isLoading, setIsLoading ] = useState(false);

    useEffect(() => {
        async function fetchData() {
            
            const data = {
                entidad: usuario.entidad,
                uidModulo: usuario.uidModulo,
                uidUsuario: usuario.uidUsuario
            }
            
            await socket.emit('ubicacion-tiposAtencion', data,  async( lista )=> {
                const aten= await lista.filter((item) => item.checked === true )
                localStorage.setItem( 'tiposAtencion',  aten.map((item) => item.uidTipoAtencion ))
                // setPendientes( pend )
             })
        }

        fetchData();
        return () => {
            socket.off('ubicacion-tiposAtencion')
        }
    }, [socket, usuario.entidad, usuario.uidModulo, usuario.uidUsuario])

    useEffect(() => {
        
        async function fetchData() {
            
            await socket.on('lista-Modulos',  ( lista )=> {
                console.log(lista)
                const aten= lista.filter((item) => item.checked === true )
                localStorage.setItem( 'tiposAtencion',  aten.map((item) => item.uidTipoAtencion ))
                // setPendientes( pend )
             })
        }

        fetchData();
        return () => {
            socket.off('lista-Modulos')
        }
    }, [socket])


    useEffect(() => {
        async function fetchData() {
            socket.on('tickets-pendientes', ( pend )=> {

                // actualizamos los tipos de atencion asignados
                const asigndos= localStorage.getItem('tiposAtencion').split(",");
                const filteredArray = pend.filter(item => asigndos.indexOf(item.uidTipoAtencion) >= 0);
                setPendientes(filteredArray);
             })
        }

        fetchData();

        return () => {
            socket.off('tickets-pendientes')
        }
    }, [socket])

    
    // LLamar los tickets pendientes
    useEffect(() => {
        
        // await getUltimos().then( tickets => setTickets(tickets) )
        const getPendiente = async () => {
            const tickets = await getPendientes();
            const asigndos= localStorage.getItem('tiposAtencion') === null ? [] : localStorage.getItem('tiposAtencion').split(",")
            const filteredArray = tickets.filter(item => asigndos.indexOf(item.uidTipoAtencion) >= 0);
            
            setPendientes(filteredArray);
        };
    
        getPendiente(); 
        
    }, [])
    
    
    const siguienteTicket = () => {
        
        const ultimoTicket= document.getElementById('ticketAnterior');
        const ticketAnterior= (ultimoTicket) ? ultimoTicket.value : '';
        setIsLoading(true)
        socket.emit( 'siguiente-ticket-llamar', { usuario, ticketAnterior }, ( ticket ) => {
            setIsLoading(false)
            console.log(ticket)
            setTicket( ticket );
        })
    }

    const volverLlamar = ( nombrePaciente, numeroTicket, uidTicket ) => {
        socket.emit( 'volver-llamar', { uidTicket, entidad }, ( ticket ) => {
            console.log(ticket);
        })
    }

    const handelDataFromTable = ( ticket ) => {
        setTicket( ticket );
    }

    const terminarTicket = () => {
        
        const ultimoTicket= document.getElementById('ticketAnterior');
        const ticketAnterior= (ultimoTicket) ? ultimoTicket.value : '';
        if( ticketAnterior=== '') {
            return UseSweetAlert( 'Atención!', 'No tiene Ticket cargado', 'warning' )
        }
        socket.emit( 'terminar-ticket', { usuario, ticketAnterior }, ( ticket ) => {
            setTicket( ticket );
        })
    }

    

    if( usuario.uidUsuario === null ) {
        return(
            <>
            </>
        )
    }else if( usuario.uidModulo === null  ) {
        return( <NoCargaModulo /> )
    }
    else if( !pantallas.includes("escritorios") ) {
        return( <NoAcceso /> )
    }else{

        return (
            < >
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''}`} style={{minHeight:'100vh'}} >
                 
                    <div className='row '>
                        {/* <div className="mt-1 col-lg-4 col-12">
                            <img id="imgPrint" style={{height:'auto',width:'100%'}} src={ logo } alt=''/>
                        </div> */}
        
                        {/* <div className="mt-1 col-lg-7 col-12">
                            <h2><span>{ usuario.agente }</span></h2>
                            <h4> Modulo: <span className='text-success'>{ usuario.modulo }</span> </h4>
                        </div> */}
                    
                    
                    </div>
                                       
                    <div className='row' height="10vh">

                        {
                            pendientes && 
                            ( 
                                pendientes.length!==0 &&
                                    (
                                        
                                        pendientes.map((ticket, i) =>{
                                            
                                            return( 
                                                <div className="col-md-2 col-6 mt-2 " key={i}>
                                                    <div className={ `card border-${colores[i]} mx-sm-1 p-3 d-flex align-items-center justify-content-center shadow`}>
                                                        
                                                        <div className={ `card border-${colores[i]} shadow text-${colores[i]} p-3 my-card rounded-circle` } >
                                                            <span className={ticket.icono} aria-hidden="true"></span>
                                                        </div>
                                                        
                                                        <div className={ `text-${colores[i]} text-center mt-2 `}> <h5> {ticket.sigla}</h5> </div>
                                                        
                                                        <div className={ `text-${colores[i]} text-center mt-1 `}> <h3>{ticket.cantidadTickets}</h3> </div>
                                
                                                    </div>
                                                </div>
                                            )
                                    
                                        })
                                    )
                                    
                                    
                            )
                        
                            
                        }
                        
                    
        
                    </div>

                    <div className='row mt-5 p-3'>

                        <div className='form-group col-lg-6 col-12 '>
            
                            <div className="d-flex justify-content-center mt-5">
                                <div className='d-grid gap-2 col-lg-6 col-12 mx-auto'>
            
                                    { ticket  && (
            
                                            Object.keys(ticket).length !==0 ? (
                                                !ticket.uidTicket ? (
                                                    <div className='row'>
                    
                                                    
                                                    </div>
                                                ): (

                                                    <div className='row'>
                        
                                                        <div className="card border-dark mx-sm-1 p-3 d-flex align-items-center justify-content-center shadow">
                                                            <input type='hidden' id='ticketAnterior' value={ ticket.uidTicket} />
                                                            <div className='col-12 text-center fs-3'> Atentiendo el Ticket No. </div> 
                                                            <div className='col-12 text-center fs-4 text-success'>  { ticket.codigoTipoAtencion }-{ ticket.numeroTicket } </div>
                                                            
                                                            {   ticket.nombrePaciente.trim() !=="" && (
                                                                <div className='col-12 text-center fs-6 '> Paciente: { ticket.nombrePaciente } </div> 
                                                            )}
                                                            <div className='col-12 text-center fs-6 '> Servicio: { ticket.tipoAtencion } { ticket.indPrioridad === 1 && ( "Priorizado") } </div> 
                                                            <div className='col-12 text-center fs-6 '> 
                                                                <button className='btn btn-primary' 
                                                                        onClick={ () => volverLlamar ( ticket.nombrePaciente, ticket.numeroTicket, ticket.uidTicket )} 
                                                                > 
                                                                    Volver a llamar 
                                                                </button> 
                                                            </div> 
                                                            
                        
                                                        </div>
                                                    </div>
                                                ) 

                                            ): (
                                                <div className='row'>
                    
                                                    <div className="card border-dark mx-sm-1 p-3 d-flex align-items-center justify-content-center shadow">
                                                        <div className='col-12 text-center fs-3'> No Hay Tickets Pendientes </div> 
                                                    </div>
                                                </div>
                                            )
            
                                                
                                        
                                    ) }
            
                                </div>
                            </div>
                                
                            <div className='row ustify-content-center mt-2'>
                                
                                    <div className='d-grid gap-2 col-lg-4 col-12 mx-auto m-2'>
                                        <button className='btn  btn-primary rounded-pill' onClick={ () => siguienteTicket()} > 
                                            <i className="fa-solid fa-check-double"></i> Siguiente 
                                        </button>
                                    </div>

                                    
                                    
                                    <div className='d-grid gap-2 col-lg-4 col-12 mx-auto m-2'>
                                        <button className='btn btn-danger rounded-pill' onClick={ () => terminarTicket()} > 
                                            <i className="fa-regular fa-circle-xmark"></i> Terminar 
                                        </button>
                                    </div>

                                    
                                
                            </div>

                        </div>

                        <TablaTicketsPendientes usuario= {usuario }
                                                dataFromTable= { handelDataFromTable } />

                    </div>
                
                                    

                </div>    
            </>
        )
    }
}
